import { ServerMessage } from 'components/ServerMessageController';
import { UserInfo } from 'components/UserInfo';
import { matchModeManager } from '../models/MatchModeManager';
import { MatchModeManager } from '../models/MatchModeManager';
import { ChatActions } from './ChatActions';
import { Request } from './Request';
import { LadderPopup } from 'components/LadderPopup';
import { matchSearchListManager } from 'components/MatchSearchListManager';
import SocketConnection from '../components/SocketConnection';

import { ReactChat } from 'react/ReactChat';
import { CacheableDataObject } from 'models/CacheableDataObject';
import keyCodes from 'components/KeyCodes';
import WindowSize from 'components/WindowSize';
import store from '../react/redux/store/store';
import { possibleTabs } from 'react/redux/reducers/matchmaking';
import sleep from "../functions/sleep";
import { userlistIsVisibleForFetch } from 'components/userlistVisibility';
import createServerMessageGate from 'session/serverMessageGate';

require('app/StartupEventManager');

$.fn.findCache = function(selector) {
	if(!this.data('findCache')) {
		this.data('findCache', {});
	}
	if(!this.data('findCache')) {
		// console.error('UNDEFINED ELEMENT');
		return $();
	}
	if(this.data('findCache')[selector]) {
		return this.data('findCache')[selector];
	}
	else {
		const result = this.find(selector);
		this.data('findCache')[selector] = result;
		return result;
	}
};

$.fn.ladderSortable = function(options) {
	let list = $(this);

	if(!options.items) {
		throw new Error('items is a required option');
	}
	let defaultOptions = {
		axis: 'y',
		tolerance: 'pointer',
		items: null,
		idDataElement: 'id',
		updateUrl: '',
		urlListKey: 'ids',
		update: function(e, ui) {
			var elements = list.find(defaultOptions.items).not('.template');
			var ids = [];
			elements.each(function() {
				var element = $(this);
				var chat = element.data(defaultOptions.idDataElement);
				ids.push(chat);
			});
			var data = {};
			data[defaultOptions.urlListKey] = ids;
			$.post(defaultOptions.updateUrl, data);
		}
	};

	$.extend(defaultOptions, options);

	list.sortable(defaultOptions);
};
export var Dashboard = {};
Dashboard.serverConnection = SocketConnection;
Dashboard.startupEvents = new Promise(function(resolve, reject) {
	Dashboard.startupEventsResolve = resolve;
});

Dashboard.ladderPopup = LadderPopup.create;
Dashboard.waitForChat = null;
// The netplay page's #dashboard, looked up each time: client navigation brings
// the page (and a new element) in and out of the page area.
Object.defineProperty(Dashboard, 'dashboard', { get: () => $('#dashboard') });
Dashboard.chatRoomsLoaded = false;

Dashboard.startMatchWithPlayer = null;
Dashboard.hostCodePopup = { popup: null, value: null };
Dashboard.retrieveHostCode = function() {
	var value = null;
	if(Dashboard.hostCodePopup.popup) {
		value = Dashboard.hostCodePopup.popup.get().find('input').val();
	}
	return value;
};
// Socket pushes wait until startup has loaded the user (on every page, not
// only where #dashboard exists); StartupEventManager opens the gate.
Dashboard.serverMessages = createServerMessageGate((message) => {
	Dashboard.performOpenSearchUpdate(message, undefined, Request.FROM_WEBSOCKET);
});
Dashboard.parseGeneralData = function(message) {
	if(message && message.authentication === false) {
		Dashboard.serverConnection.authenticationFail = true;
	}
	if(Dashboard.dashboard.data('search_disabled')) {
		Dashboard.dashboard.data('search_disabled', false);
	}
	Dashboard.serverMessages.receive(message);
};
Dashboard.lastKeepOnScreen = null;
Dashboard.calculateKeepOnScreenPosition = (container, startPoint) => {
	container = $(container);
	if(!startPoint) {
		startPoint = {};
		startPoint.x = container.offset().left;
		startPoint.y = container.offset().top;
	}

	const containerHeight = container.height();
	let height = null;
	if(startPoint.minHeight) {
		if(startPoint.minHeight > containerHeight) {
			height = startPoint.minHeight;
		}
		else {
			height = containerHeight;
		}
	}
	else {
		height = containerHeight;
	}
	const width = container.width() + 8;

	const newPosition = {
		top: startPoint.y,
		left: startPoint.x,
	};

	const { innerWidth, innerHeight } = window;
	const rect = {
		height,
		width,
	};

	if(startPoint.y + height > innerHeight) {
		newPosition.top -= height;
	}

	if(startPoint.x + rect.width > innerWidth) {
		newPosition.left -= rect.width;
	}

	if(newPosition.top < 0) {
		newPosition.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
	}

	if(newPosition.left < 0) {
		newPosition.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
	}

	return newPosition;
};
Dashboard.keepContainerOnScreen = function(container, startPoint) {

	if(!startPoint) {
		startPoint = {};
		startPoint.x = container.offset().left;
		startPoint.y = container.offset().top;
	}

	Dashboard.lastKeepOnScreen = {
		'element': container,
		'startPoint': startPoint
	};

	const newPosition = Dashboard.calculateKeepOnScreenPosition(container, startPoint);


	container.css('left', `${newPosition.left}px`);
	container.css('top', `${newPosition.top}px`);
};

Dashboard.mainChatHolderTemplate = $('.chat_holder.template_visible');

Dashboard.performOpenSearchUpdate = function(response, extract, messageType = Request.FROM_HTTP) {
	if(extract) {
		const replacement = {};
		if(!response[extract]) {
			return;
		}
		replacement[extract] = response[extract];
		delete response[extract];
		response = replacement;
	}
	CacheableDataObject.parseReferences(response);
	for(const key in response) {
		if(response.hasOwnProperty(key) && ServerMessage[key] instanceof Function) {
			CacheableDataObject.parseReferences(response[key]);
			if(ServerMessage[key](response, messageType) === false) {
				break;
			}
		}
	}
};


var body = Dashboard.body = $('body');

Dashboard.userInfoContainer = $('#user_info');

Dashboard.pendingFriendRequests = {};
Dashboard.header = $('#header');

Dashboard.namedTabList = {};
Dashboard.retrieveNamedTab = function(name) {
	return Dashboard.namedTabList[name] || $();
};

Dashboard.userlistIsVisible = function() {
	return userlistIsVisibleForFetch(store.getState().chat);
};

Dashboard.UserInfo = new UserInfo(Dashboard.userInfoContainer);

Dashboard.isCompact = WindowSize.isCompact;
Dashboard.isTiny = WindowSize.isTiny;
Dashboard.isMediumOrSmaller = WindowSize.isMediumOrSmaller;
Dashboard.isLarge = WindowSize.isLarge;
Dashboard.isMediumOrLarger = WindowSize.isMediumOrLarger;

Dashboard.getDataForLadder = function(ladderId) {
	if(myUser.preferred_games.retrieve(ladderId)) {
		return myUser.preferred_games.retrieve(ladderId);
	}
	return {};
};

Dashboard.updatePreferredGames = function(newPreferredGames) {
	if(newPreferredGames) {
		myUser.preferred_games.update(newPreferredGames);
	}

};

Dashboard.calculateWindowHeight = function() {
	let dashboard = Dashboard.dashboard;

	const windowElement = $(window);
	let windowHeight = windowElement.height();

	windowHeight = windowHeight - 184; //Extra space

	Dashboard.HIDE_TAB_CONTAINER_HEIGHT = -200;

	dashboard = dashboard.add(Dashboard.body);

	if(dashboard.hasClass('dashboard-sm')) {
		windowHeight = windowHeight - 32;//MORE PADDING FOR TALL WINDOWS
	}
	else {
		windowHeight = windowHeight + 0;
	}

	if(windowHeight < Dashboard.HIDE_TAB_CONTAINER_HEIGHT) {
		Dashboard.body.addClass('dashboard-short');
	}
	else {
		Dashboard.body.removeClass('dashboard-short');
	}
	if(Dashboard.lastKeepOnScreen) {
		Dashboard.keepContainerOnScreen(Dashboard.lastKeepOnScreen.element,
			Dashboard.lastKeepOnScreen.startPoint);
	}
	return Dashboard.lastWindowHeightValue = windowHeight;
};

WindowSize.onChange(() => {
	Dashboard.calculateWindowHeight();
});

Dashboard.calculateWindowHeight();

Dashboard.sleep = sleep;
Dashboard.matchmakingPaneIsVisible = function() {
	const { selectedTab } = store.getState().matchmaking;
	return selectedTab === possibleTabs.matchmaking;
};
Dashboard.isMatchOnlyStreamView = function() {
	const { selectedTab } = store.getState().matchmaking;
	return selectedTab === possibleTabs.match_only_view;
};
Dashboard.battlePaneIsVisible = function() {
	const { selectedTab } = store.getState().matchmaking;
	return selectedTab === possibleTabs.battle;
};


Dashboard.keyCodes = keyCodes;

window.debugGlobals = {};
window.debugGlobals.Dashboard = Dashboard;
window.Dashboard = Dashboard;